import AdminGuard from '@/views/dashboard/guards/AdminGuard'
import QuestionBank from './QuestionBank'
import QuestionBankDetail from './QuestionBankDetail'
import QuestionBankSearch from './QuestionBankSearch'

export default [
    { path: 'banksoal', component: QuestionBank, beforeEnter: AdminGuard, name: 'questionbank', meta: { title: 'Bank Soal' } },
    { path: 'banksoal/cari', component: QuestionBankSearch, beforeEnter: AdminGuard, name: 'questionbank.search', meta: { title: 'Cari Bank Soal' } },
    { path: 'banksoal/:questionbank_id', component: QuestionBankDetail, beforeEnter: AdminGuard, name: 'questionbank.detail' },
]
